export const pdfStyles = {
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    color: "#333333"
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  tableCellHeader: {
    margin: "auto",
    fontSize: 10,
    fontWeight: 500
  },
  tableCell: {
    margin: "auto",
    fontSize: 8
  },
  one: {
    backgroundColor: "#fff"
  },
  two: {
    backgroundColor: "#f9f9f9"
  },
  paddingHorizontal: {
    paddingHorizontal: 35
  },
  pb: {
    paddingBottom: 65
  },
  flex: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap"
  }
};

export const pdfcolors = [
  "#e6194b",
  "#3cb44b",
  "#4363d8",
  "#f58231",
  "#911eb4",
  "#46f0f0",
  "#f032e6",
  "#fabebe",
  "#008080",
  "#e6beff",
  "#9a6324",
  "#800000",
  "#aaffc3",
  "#808000",
  "#ffd8b1",
  "#000075",
  "#808080"
];



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/pdf.styles.js